import type { FC } from 'react'

import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import { OrgchartEmployeeFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'

import Teams from './Teams'
import WorkInformation from './WorkInformation'

interface Props {
  employee: OrgchartEmployeeFragment
  canSeeTeams: boolean
  hasLegacyJobCatalog: boolean
}

const ProfileDetails: FC<Props> = ({ employee, canSeeTeams, hasLegacyJobCatalog }) => {
  const jobTitle = employee.referenceContract?.jobTitle
  const jobLevel = employee.referenceContract?.jobCatalogLevel
  const jobLevelName = jobLevel?.name
  const jobRoleName = jobLevel?.role?.name

  const jobTitleLabel = () => {
    if (jobTitle) return jobTitle
    if (!hasLegacyJobCatalog)
      return employee.referenceContract?.jobCatalogTreeLevel?.jobCatalogTitle || ''
    if (jobLevelName === '__default__') return jobRoleName

    return [jobRoleName, jobLevelName].filter(Boolean).join(', ')
  }

  return (
    <>
      <Box
        paddingTop="s32"
        paddingBottom="s24"
        gap="s16"
        flexDirection="column"
        alignItems="center"
        border={{
          bottom: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }}
      >
        <Avatar url={buildUrl(employee.avatar?.url)} size="s140" label={employee.fullName} />
        <Box flexDirection="column" alignItems="center" textAlign="center" paddingX="s16">
          <Text.Header1 color="grey1000">{employee.fullName}</Text.Header1>
          <Text.Normal color="grey800" size="300" weight="medium">
            {jobTitleLabel()}
          </Text.Normal>
          {employee.pronouns && (
            <Text.Normal color="grey800" size="200" weight="normal">
              {employee.pronouns}
            </Text.Normal>
          )}
        </Box>
      </Box>
      <WorkInformation employee={employee} />
      {canSeeTeams && <Teams employeeTeams={employee.membershipsConnection?.nodes} />}
    </>
  )
}

export default ProfileDetails
